import styled from "styled-components";

export const MissionDetailsModalStyled = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  min-width: 600px;
  height: 100vh;
  top: 0;
  left: 0;
  font-family: "Readex Pro", sans-serif;
  z-index: 1000;
`;
